import { LocalFirstVisitCase } from '@kp/shared/first-visit/local-first-visit-case.enum';
import { RemoteFirstVisitCase } from '@kp/shared/first-visit/remote-first-visit-case.enum';

export const FirstVisitCase = {
  ...LocalFirstVisitCase,
  ...RemoteFirstVisitCase,
};

export type FirstVisitCase = LocalFirstVisitCase | RemoteFirstVisitCase;
